module.exports = __webpack_public_path__ + "images/avatars/female/7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/7.svg
// module id = PAlv
// module chunks = 55